import { Link } from "react-router-dom";
import { NEWS_HEADER_IMAGE_URL } from "../constants/news.assets";
import {
  NEWS_COLORS,
  NEWS_CONTENT_CLASS,
} from "../constants/news.constants";
import { newsHero } from "../data/newsContent";
import { ROUTE_PATHS } from "@/routes/routePaths";
import { cn } from "@/lib/utils";

export function NewsHero() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: NEWS_COLORS.primary }}
    >
      <div
        className="pointer-events-none absolute -right-16 top-0 h-72 w-72 rounded-full bg-white/10 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute bottom-0 left-1/4 h-40 w-40 rounded-full bg-black/10 blur-2xl"
        aria-hidden
      />

      <div
        className={cn(
          NEWS_CONTENT_CLASS,
          "relative grid gap-8 pb-12 pt-12 sm:pb-16 sm:pt-16 lg:grid-cols-[0.95fr_1.15fr] lg:items-end lg:gap-6 lg:pb-14"
        )}
      >
        <div className="pb-4 lg:pb-10">
          <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            {newsHero.title}
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-white/90 sm:text-lg">
            {newsHero.subtitle}
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-2xl lg:max-w-none lg:-mb-2">
          <img
            src={NEWS_HEADER_IMAGE_URL}
            alt=""
            className="h-auto w-full object-contain object-bottom drop-shadow-lg"
            decoding="async"
          />
        </div>
      </div>

      {/* Soft wave into page content */}
      <div className="absolute inset-x-0 bottom-0 h-8 bg-white [clip-path:ellipse(70%_100%_at_50%_100%)] sm:h-10" />
    </section>
  );
}

export function NewsBreadcrumb({ current }: { current: string }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(NEWS_CONTENT_CLASS, "py-4 text-sm text-gray-500")}
    >
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link
            to={ROUTE_PATHS.HOME}
            className="transition-colors hover:text-gray-800"
          >
            Home
          </Link>
        </li>
        <li aria-hidden className="text-gray-300">
          &gt;
        </li>
        <li>
          <Link
            to={ROUTE_PATHS.NEWS}
            className="transition-colors hover:text-gray-800"
          >
            News & Updates
          </Link>
        </li>
        <li aria-hidden className="text-gray-300">
          &gt;
        </li>
        <li className="truncate font-medium text-gray-700">{current}</li>
      </ol>
    </nav>
  );
}
